"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.absolutePropTypes = exports.absoluteDefaultProps = undefined;

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var absoluteDefaultProps = exports.absoluteDefaultProps = {
  both: false,
  children: null,
  horizontal: false,
  vertical: false
};
var absolutePropTypes = exports.absolutePropTypes = {
  both: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  horizontal: _propTypes2.default.bool,
  vertical: _propTypes2.default.bool
};